import { createFileRoute } from '@tanstack/react-router'
import { DistributorOverviewScreen } from '../features/distributors/DistributorOverviewScreen'

/** `/distributors/$id/overview` — таб «Обзор» карточки тенанта (PA-12,
 *  D17 §2.3). Содержимое = бывший DistributorDetailScreen без AdminShell —
 *  shell, breadcrumbs и TabBar теперь живут в layout-route
 *  `distributors.$id.tsx`. */
export const Route = createFileRoute('/distributors/$id/overview')({
  component: DistributorOverviewRoute,
})

function DistributorOverviewRoute() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  if (!Number.isFinite(numericId)) {
    // Layout-route уже отрисует inline-ошибку при NaN; здесь — defensive
    // fallback, чтобы child-таб не упал на useDistributorDetail(NaN).
    return null
  }
  return <DistributorOverviewScreen distributorId={numericId} />
}
